import React, { Component } from 'react';
import moment from 'moment';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import SingleDatePickerWrapper from '../../Common/SingleDatePickerWrapper/SingleDatePickerWrapper';
import TimeOptions from '../../Common/TimeOptions/TimeOptions';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import TimezoneOptions from '../../Common/TimezoneOptions/TimezoneOptions';
import TimezoneCAOptions from '../../Common/TimezoneCAOptions/TimezoneCAOptions';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class FlexpassDates extends Component {
	handleDayChange = (day, input) => {
		this.props.handleChangeDateWizard(day, input.props.object, input.props.name);
	}

	handleDayEventChange = (day, input) => {
		this.props.handleChangeDateEvent(day, input.props.object, input.props.name, input.props.event);
	}

	handleChangeDateEvent = (value, key, name, eventIndex) => {
        const dates = [...this.state.dates];
        if(name){
            dates[eventIndex][key][name] = value;
        } else {
            dates[eventIndex][key] = value;
        }

        // if date of event changes, change also the public end date and box office end date
        if(key === "date"){
            dates[eventIndex]['public']['end_date'] = value;
            dates[eventIndex]['boxoffice']['end_date'] = value;
        }
        this.setState({ dates });
    }
	
    render() { 
        return ( 
            <div className="showtix-section showtix-section__padding-1 showtix-background__primary-2">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h1>{strings.title}</h1>
                            <h3>{strings.subTitle}</h3>
                        </div>
                    </div>

                    <div className="row">
						<div className="col-12 col-md-4">
							<div className="showtix-form__group">
								<label className="showtix-label" htmlFor="venue-timezone">
                                    {strings.timezone} *
									<span id="tooltip-timezone" className="showtix-tooltip">!</span>
									<Tooltip placement="top" target="tooltip-timezone">
                                        {strings.timezoneTooltip}
									</Tooltip>
								</label>

								<div className="showtix-form__select">
									<select className="showtix-input"
											object="timezone"
											id="venue-timezone"
											value={this.props.wizard.timezone}
											onChange={this.props.handleChangeWizard}
									>
										<TimezoneOptions />
										<TimezoneCAOptions />
									</select>
								</div>
							</div>
						</div>
                    </div>

                    <div className="row">
						<div className="col-12 col-md-4">
							<div className="showtix-form__group">
								<label className="showtix-label" htmlFor="wizard-presale-start_date">
                                    {strings.presaleStart}
									<span id="tooltip-presaleStart" className="showtix-tooltip">!</span>
									<Tooltip placement="top" target="tooltip-presaleStart">
                                        {strings.presaleStartTooltip}
									</Tooltip>
								</label>

								<div className="showtix-form__multiple">
									<div className="showtix-form__input">
										<SingleDatePickerWrapper 
											object="presale" 
											name="start_date" 
											id="wizard-presale-start_date"
											disablePrevious={true}
											handleDayChange={this.handleDayChange}
											selectedDays={this.props.wizard.presale.start_date}
										/>
									</div>

									<div className="showtix-form__select">
										<select
											className="showtix-input"
											object="presale" 
											name="start_time" 
											id="wizard-presale-start_time"
											onChange={this.props.handleChangeWizard}
											value={this.props.wizard.presale.start_time}
										>
											<TimeOptions />
										</select>
									</div>
								</div>
							</div>
						</div>

						<div className="col-12 col-md-4">
							<div className="showtix-form__group">
								<label className="showtix-label" htmlFor="wizard-presale-end_date">{strings.presaleEnd}</label>

								<div className="showtix-form__multiple">
									<div className="showtix-form__input">
										<SingleDatePickerWrapper 
											object="presale" 
											name="end_date" 
											id="wizard-presale-end_date"
											disablePrevious={true}
											handleDayChange={this.handleDayChange}
											selectedDays={this.props.wizard.presale.end_date}
										/>
									</div>

									<div className="showtix-form__select">
										<select
											className="showtix-input"
											object="presale" 
											name="end_time" 
											id="wizard-presale-end_time"
											onChange={this.props.handleChangeWizard}
											value={this.props.wizard.presale.end_time}
										>
											<TimeOptions />
										</select>
									</div>
								</div>
							</div>
						</div>

						<div className="col-12 col-md-4">
							<div className="showtix-form__group">
								<label className="showtix-label" htmlFor="wizard-presale-password">{strings.presalePassword}</label>

								<div className="showtix-form__input">
									<input
										className="showtix-input"
										type="text"
										object="presale"
										name="password"
										id="wizard-presale-password"
										onChange={this.props.handleChangeWizard}
										value={this.props.wizard.presale.password}
									/>
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-12 col-md-4">
							<div className="showtix-form__group">
								<label className="showtix-label" htmlFor="wizard-public-start_date">
                                    {strings.publicStart} *
									<span id="tooltip-publicStart" className="showtix-tooltip">!</span>
									<Tooltip placement="top" target="tooltip-publicStart">
                                        {strings.publicStartTooltip}
									</Tooltip>
								</label>

								<div className="showtix-form__multiple">
									<div className="showtix-form__input">
										<SingleDatePickerWrapper 
											object="public" 
											name="start_date" 
											id="wizard-public-start_date"
											disablePrevious={true}
											handleDayChange={this.handleDayChange}
											selectedDays={this.props.wizard.public.start_date}
										/>
									</div>

									<div className="showtix-form__select">
										<select
											className="showtix-input"
											object="public" 
											name="start_time" 
											id="wizard-public-start_time"
											onChange={this.props.handleChangeWizard}
											value={this.props.wizard.public.start_time}
										>
											<TimeOptions />
										</select>
									</div>
								</div>
								{this.props.isWizardError &&
									<div className="showtix-note error">
										{strings.publicSaleError}
									</div>
								}
							</div>
						</div>

						<div className="col-12 col-md-4">
							<div className="showtix-form__group">
								<label className="showtix-label" htmlFor="wizard-public-end_date">
                                    {strings.publicEnd} *
									<span id="tooltip-publicEnd" className="showtix-tooltip">!</span>
									<Tooltip placement="top" target="tooltip-publicEnd">
                                        {strings.publicEndTooltip}
									</Tooltip>
								</label>

								<div className="showtix-form__multiple">
									<div className="showtix-form__input">
										<SingleDatePickerWrapper 
											object="public" 
											name="end_date" 
											id="wizard-public-end_date"
											disablePrevious={true}
											handleDayChange={this.handleDayChange}
											selectedDays={this.props.wizard.public.end_date}
										/>
									</div>

									<div className="showtix-form__select">
										<select
											className="showtix-input"
											object="public" 
											name="end_time" 
											id="wizard-public-end_time"
											onChange={this.props.handleChangeWizard}
											value={this.props.wizard.public.end_time}
										>
											<TimeOptions />
										</select>
									</div>
								</div>
								{this.props.isWizardError &&
									<div className="showtix-note error">
										{strings.publicSaleError}
									</div>
								}
							</div>
						</div>

						<div className="col-12 col-md-4"></div>
					</div>

					<div className="row">
						<div className="col-12 col-md-4">
							<div className="showtix-form__group">
								<label className="showtix-label" htmlFor="wizard-boxoffice-end_date">
                                    {strings.boxOfficeEnd} *
									<span id="tooltip-boxOfficeEnd" className="showtix-tooltip">!</span>
									<Tooltip placement="top" target="tooltip-boxOfficeEnd">
                                        {strings.boxOfficeEndTooltip}
									</Tooltip>
								</label>

								<div className="showtix-form__multiple">
									<div className="showtix-form__input">
										<SingleDatePickerWrapper 
											object="boxoffice" 
											name="end_date" 
											id="wizard-boxoffice-end_date"
											disablePrevious={true}
											handleDayChange={this.handleDayChange}
											selectedDays={this.props.wizard.boxoffice.end_date}
										/>
									</div>

									<div className="showtix-form__select">
										<select
											className="showtix-input"
											object="boxoffice" 
											name="end_time" 
											id="wizard-boxoffice-end_time"
											onChange={this.props.handleChangeWizard}
											value={this.props.wizard.boxoffice.end_time}
										>
											<TimeOptions />
										</select>
									</div>
								</div>
							</div>
						</div>

						<div className="col-12 col-md-4"></div>

						<div className="col-12 col-md-4"></div>
					</div>
					{ this.props.flexpassDetails.prices.length > 0  &&
						<div className="row">
							<div className="col-12">
								<div className="showtix-form__group">
									<button
										className="showtix-button showtix-background__primary-1"
										onClick={this.props.toggleDatesModal}
									><span>{strings.customizePricing}</span></button>
								</div>
							</div>
						</div>
					}
                </div>
            </div>
        )
    }
}
 
export default FlexpassDates;


// WEBPACK FOOTER //
// ./src/components/CreateFlexpass/FlexpassDates/FlexpassDates.js